import React from 'react'

const ChevronRight = ({fill}:{fill:string}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.734835 0.734835C0.881282 0.588388 1.11872 0.588388 1.26517 0.734835L4.26516 3.73484C4.41161 3.88128 4.41161 4.11872 4.26516 4.26516L1.26517 7.26517C1.11872 7.41161 0.881282 7.41161 0.734835 7.26517C0.588388 7.11872 0.588388 6.88128 0.734835 6.73484L3.46967 4L0.734835 1.26517C0.588388 1.11872 0.588388 0.881282 0.734835 0.734835Z" fill={fill} />
        </svg>
    )
}

export default ChevronRight